const adminEducationRoutes = [
    { path: 'education/distribution', component: () => import('pages/sot.bot.admin/distribution/DistributionPage.vue') }, // рассылки v2 (composition API + ui-kit),
    {
        name: 'deliveries',
        path: 'education/deliveries',
        component: () => import('pages/sot.bot.admin/deliveries/DeliveriesIndex.vue'),
    },
    { path: 'education/statistics/:id?', name: 'statistics', component: () => import('pages/sot.bot.admin/statistics/Statistics.vue') },
    {
        name: 'enrolls',
        path: 'education/enrolls',
        component: () => import('pages/sot.bot.admin/enrolls/EnrollsIndex.vue'),
    },
    {
        name: 'do_detect_schools',
        path: 'do_detect_schools',
        component: () => import('pages/sot.bot.admin/schools20/services/DoDetectSchools.vue'),
    },
    { path: 'education/mockup', component: () => import('src/pages/mockup/Mockup.vue') }, // редактор макетов,
    { path: 'education/documents', component: () => import('pages/sot.bot.admin/documents20/Documents20Index.vue') }, // документы,
    { path: 'education/exercise-results-library', component: () => import('pages/sot.bot.admin/library/ExerciseResultsLibrary/ExerciseResultsLibrary.vue') }, // Библиотека решений заданий  (https://onedrive.live.com/edit?id=66183ECD32C4C9C5!4293&resid=66183ECD32C4C9C5!4293&ithint=file%2cdocx&authkey=!AMTpDltTyjqLeKs&wdo=2&cid=66183ecd32c4c9c5),
    { path: 'education/exercise/:id?', name: 'exercise', component: () => import('pages/sot.bot.admin/exercises/ExercisesPage.vue') },
    // Старая лента заданий — для сравнения аналитиками, удалить вместе со старой реализацией
    { path: 'education/exercise-old/:id?', name: 'exercise-old', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
    { path: 'education/groups-old', component: () => import('pages/sot.bot.admin/groups/GroupsIndex.vue') },
    { path: 'education/flows', name: 'flows', component: () => import('pages/sot.bot.admin/flows/FlowsIndex.vue') },
    { path: 'education/groups', component: () => import('pages/sot.bot.admin/groups20/Groups20Index.vue') },
    { path: 'education/webinars', component: () => import('pages/sot.bot.admin/webinars/WebinarsPage.vue') },
    { path: 'education/webinars/:id', component: () => import('pages/sot.bot.admin/webinars/WebinarDetail') },
];

export default adminEducationRoutes;
